import http from '../util/http2.js'

// 活动列表
export function activityList(params) {
    return http.get("/app-api/crm-server/activity-showings/list", params)
}
// 门店列表
export function storeList(params) {
    return http.get("/app-api/erp-server/store/list", params)
}
// 活动详情门票信息
export function activitydetails(params) {
    return http.get("/app-api/crm-server/activity-showings/details", params)
}


// 增加购票人信息
export function addBuyer(params) {
    return http.post("/app-api/crm-server/buyer/add", params)
}
// 修改购票人信息
export function editBuyer(params) {
    return http.post("/app-api/crm-server/buyer/edit", params)
}
// 删除购票人信息
export function delBuyer(params) {
    return http.get("/app-api/crm-server/buyer/del", params)
}
// 查询购票人信息
export function listBuyer(params) {
    return http.get("/app-api/crm-server/buyer/list", params)
}
// 查询购票人详情
export function detailsBuyer(params) {
    return http.get("/app-api/crm-server/buyer/details", params)
}
// 改签
export function rebookTicket(params) {
    return http.post("/app-api/crm-server/activity-showing-transaction/rebooking", params)
}
// 场次选择
export function reservationTicket(params) {
    return http.post("/app-api/crm-server/activity-showing-transaction/booking", params)
}
// 发起活动门票预约交易
export function putTransactionOrder(params) {
    return http.post("/app-api/crm-server/activity-showing-transaction/put-transaction", params)
}


// 获取场次日历
export function activityShowingsDateList(params) {
    return http.get("/admin-api/crm-server/activity-showings-daily/list-plan", params)
}
// 获取场次信息及预约情况
export function getActivitySessionInfoByStatus(params) {
    return http.post("/admin-api/crm-server/activity-showings-daily/list-daily-status", params)
}
// 根据时间获取门票列表
export function getTicketListByTime(params) {
    return http.post("/admin-api/crm-server/activity-showings-v2/ticket-list", params)
}

//版本3
// 推荐预约入场时间v3
export function getEntryTimesList(params) {
    return http.post("/app-api/crm-server/activity-showing-transaction-v3/recommend-entry-times", params)
}
// 根据门店和票时长获取可购买门票列表v3
export function getAvailableList(params) {
    return http.get("/app-api/crm-server/store-ticket/available-list", params)
}
// 发起活动门票预约交易v3
export function putTransactionOrderV3(params) {
    return http.post("/app-api/crm-server/activity-showing-transaction-v3/put-transaction-main-page", params)
}
// 改签
export function rebookTicketV3(params) {
    return http.post("/app-api/crm-server/activity-showing-transaction-v3/rebooking", params)
}
// 场次选择
export function reservationTicketv3(params) {
    return http.post("/app-api/crm-server/activity-showing-transaction-v3/booking", params)
}
// 设置购票人
export function setupBuyerv3(params) {
    return http.post("/app-api/crm-server/activity-showing-transaction-v3/setup-buyer", params)
}